<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed && pageReady" class="p-3 flex flex-column flex-auto">
    <div>
        <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:10px;">
            <h3 style="margin:0;">Membership</h3>
            <button pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToList()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to List</span>
            </button>
        </div>
        
        <div class="surface-card p-4 shadow-2 border-round">
            <div class="grid formgrid p-fluid">
                <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Membership Name</label>
                    <input [(ngModel)]="Membership.name" id="classname" type="text" [ngStyle]="{'border-color': (membershipNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
                </div>
                <div *ngIf="!membershipNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Membership name.</div>

                <div class="field mb-4 col-12">
                    <label for="MembershipDescription" class="font-medium">Description</label>
                    <p-editor [(ngModel)]="Membership.description" [style]="{'height':'320px'}">
                      <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <p-header>
                                <span class="ql-formats">
                                  <select class="ql-size">
                                    <option value="small">Small</option>
                                    <option selected value="normal">Normal</option>
                                    <option value="large">Sub Heading</option>
                                    <option value="huge">Heading</option>
                                  </select>
      
                                  <select class="ql-font">
                                    <option selected value="san serif">San-Serif</option>
                                    <option value="monospace">Monospace</option>
                                    <option value="serif">Serif</option>
                                  </select>
                                </span>
                                <span class="ql-formats">
                                  <button class="ql-bold" aria-label="Bold"></button>
                                  <button class="ql-italic" aria-label="Italic"></button>
                                  <button class="ql-underline" aria-label="Underline"></button>
                                  <button class="ql-strike" aria-label="Strike"></button>
                                  <button class="ql-script" value="sub" title="Subscript"></button>
                                  <button class="ql-script" value="super" title="Superscript"></button>
                                  <button class="ql-indent" value="-1" title="Indent"></button>
                                  <button class="ql-indent" value="+1" title="Outdent"></button>
                                </span>
                                <span class="ql-formats">
                                  <select title="Text Color" class="ql-color" defaultValue="rgb(0, 0, 0)">
                                  </select>
                                  <span class="ql-format-separator"></span>
                                  <select title="Background Color" class="ql-background" defaultValue="rgb(255, 255, 255)">
                                  </select>
                              </span>
                                <span class="ql-formats">
                                  <button class="ql-list" title="Ordered" value="ordered"></button>
                                  <button class="ql-list" title="Bullet" value="bullet"></button>
      
                                  <select title="Text Alignment" class="ql-align" >
                                    <option label="Left"></option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                  </select>            
                                </span> 
                                <span class="ql-formats">
                                  <button aria-label="Link" class="ql-link"></button>
                                </span>
                              </p-header>
                        </span>
                    </ng-template>
                    </p-editor>
                  </div>
                <div *ngIf="!membershipDescValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Membership Description.</div>
      
                <div style="clear:both;width:100%">&nbsp;</div>

                <div class="field mb-4 col-12">
                  <label for="venueonly" class="font-medium">Is this membership Venue Only or Public?</label>
                  <div style="margin-top:4px; margin-bottom:4px; font-size:0.9rem; color:#64748b;">Venue Only memberships can only be sold by staff and will not appear on the public booking wizard.</div>
                  <p-selectButton id="venueonly" [style]="{'width': '400px'}" [options]="stateOptionsVenueOnly" [(ngModel)]="Membership.venueonly"></p-selectButton>
                </div>

                <div class="field mb-4 col-12">
                  <label for="selectionmode" class="font-medium">Would you like to limit the number of uses of this membership (This sets the maximum amount of times a customer can visit using their membership in the selected time period):</label>
                  <p-selectButton  id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions" [(ngModel)]="Membership.limituses" ></p-selectButton>
                </div>

                <div *ngIf="Membership.limituses">
                 <div class="field mb-4 col-12">
                    <label for="quantity" class="font-medium">Maximum number of uses:</label>
                    <p-inputNumber [(ngModel)]="Membership.maxuses" [showButtons]="true" buttonLayout="horizontal" [min]="1" [max]="9999" mode="decimal"></p-inputNumber>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="quantity" class="font-medium">What period of time does this limit apply to:</label>
                    <p-dropdown [options]="TimePeriods" [(ngModel)]="Membership.maxusesperiod" optionLabel="name" optionValue="value" [showClear]="false"></p-dropdown>
                  </div>

                </div>

                <div class="field mb-4 col-12">
                  <label for="selectionmode" class="font-medium">Would you like to limit the amount of this kind of memberships:</label>
                  <p-selectButton id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions" [(ngModel)]="Membership.setmaxnumberofthismembership" ></p-selectButton>
                </div>

                <div *ngIf="Membership.setmaxnumberofthismembership">
                 <div class="field mb-4 col-12">
                    <label for="quantity" class="font-medium">Amount of memberships:</label>
                    <p-inputNumber [(ngModel)]="Membership.maxnumberofthismembership" [showButtons]="true" buttonLayout="horizontal" [min]="1" [max]="99999" mode="decimal"></p-inputNumber>
                  </div>
                </div>

                <div class="field mb-4 col-12">
    
                  <label for="MembershipobjFile" class="font-medium">Upload a header image for your membership. The image must be smaller than 100KB</label>
                  <div style="clear:both;width:100%">&nbsp;</div>
                  <p-fileUpload style="float:left;margin-right:10px;" mode="basic" [auto]="true" name="image" url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{Identifier}}" accept="image/*" maxFileSize="100000" (onUpload)="uploadedFile($event)" (onError)="onErrorFileUpload($event)" chooseLabel="Upload File"></p-fileUpload>
                  
                  <button *ngIf="FileChosen != null && FileChosen != ''" pButton pRipple type="button" style="float: left;margin-bottom: 10px;margin-top: 1px !important;height: 50px;" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeImage()">
                    <span style="margin-right:10px;" class="pi pi-times"></span>
                    Remove Image
                  </button>
    
                  <div style="clear:both;width:100%">&nbsp;</div>

                  <div *ngIf="FileChosen != null && FileChosen != ''">
                  <p style="margin-top:10px;">This is how your image will look in place.</p>
    
                  <div class="surface-card p-4 shadow-2 border-round packageCard" style="width: 460px;">
                    <div id="image">
                        <img src="{{ FileChosen }}" style="width: 460px;margin-top: -23px;margin-left: -23px;margin-right: -23px;">
                    </div>
                    <div style="font-weight: bold; padding: 20px;font-size:larger;">{{Membership.name}}</div>
                    <div style="padding-left: 20px; padding-right: 20px" [innerHTML]="">  
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum
                    </div>
    
                    <div>
                        <br><br>
                    </div>
                    <div>
                        <div>
                            <p-button label="Buy this Membership" icon="pi pi-check" style="width:420px;">
                            </p-button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

            <div class="field mb-4 col-12" style="width:500px;">
                <label for="selectionmode" class="font-medium">Period:</label>
                <p-selectButton  id="selectionmode" [options]="stateOptionsPeriod" [(ngModel)]="Membership.durationtype" ></p-selectButton>
              </div>
  
              <div class="field mb-4 col-12">
                <label for="dpStartTime" class="font-medium">Start Date</label>
                <div style="max-width: 500px;">
                    <p-calendar [selectOtherMonths]="true" [(ngModel)]="newStartDate" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="packagestartdate"></p-calendar>     
                  </div>
              </div>
  
              <div class="field mb-4 col-12">
                <label for="dpEndTime" class="font-medium">End Date</label>
                <div style="color:#6c757d; margin-bottom:6px; max-width:500px;">
                    The last date this membership type can be sold. It is not how long a purchased membership lasts.
                </div>
                <div style="max-width: 500px;">
                    <p-calendar [selectOtherMonths]="true" [(ngModel)]="newEndDate" [utc]="true" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" inputId="packageenddate"></p-calendar>     
                </div>
              </div>

              <div *ngIf="!membershipDateValid" class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The Start Date must be before the End Date.</div>

              <div class="field mb-4 col-12" *ngIf="Membership.durationtype == 'DURATION'">
                <label for="quantity" class="font-medium">Duration (in days)</label>
                <div style="color:#6c757d; margin-bottom:6px; max-width:500px;">
                    How long a membership runs for once it has been bought, counted from the day of purchase.
                </div>
                <p-inputNumber [(ngModel)]="Membership.duration" [showButtons]="true" buttonLayout="horizontal" [min]="1" [max]="366" mode="decimal"></p-inputNumber>
              </div>

                <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">

                  <div style="margin-bottom:20px;">
                    Please select which admissions are available for purchase in this type of membership.  You can set the minimum and maximum number they can buy at any one time.  Leaving the minimum as zero means it is optional.When the customer uses this membership the system matches them to the admissions in the package.
                  </div>

                  <div style="float:left; width:32%">
                    <div class="col-12 md:col-12 drag-column">
                      <span style="font-weight: bold;"> Available Admissions </span>
                      <p-table [value]="availableAdmissions">
                        <ng-template pTemplate="header">
                          <tr>
                            <th style="width: 90%;">Name</th>
                            <th>&nbsp;</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-admission>
                          <tr>
                            <td><span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}}</td>
                            <td>
                              <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToAdmissions(admission)">
                                <span class="pi pi-angle-right"></span>
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      <div *ngIf="availableAdmissions.length == 0" style="padding: 15px;">
                        <i>No admissions available</i>
                      </div>
                    </div>
                  </div>
                  <div style="float:left; width:65%">
                    <div class="col-12 md:col-12 drop-column" pDroppable="admissions">
                      <span style="font-weight: bold;"> Selected Admissions </span>
                      <p-table [value]="Membership.membershipadmissions">
                        <ng-template pTemplate="header" let-columns>
                          <tr>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-admission let-columns="columns" let-index="rowIndex">
                          <tr [pReorderableRow]="index">
                            <td>
                              <span class="pi pi-bars" pReorderableRowHandle></span>
                            </td>
                            <td>
                              <p-accordion style="background-color: white !important; margin-top: 5px; border: none;">
                                <p-accordionTab style="background-color: white !important; margin-top: 5px; border: none;">
                                  <p-header>
                                    <div style="width:100%">
                                        <span class="pi pi-user" style="margin-right: 10px;"></span>{{admission.name}} &nbsp;(Min:&nbsp;{{admission.min}},&nbsp;Max:&nbsp;{{admission.max}},&nbsp;Price:&nbsp;{{admission.price | currency:this.CurrencySymbol}})
                                    </div>
                                </p-header>
        
                                  <div class="surface-card p-4 shadow-2 border-round">
                                    <div class="grid formgrid p-fluid">
        
                                      <div class="field mb-4 col-12">
                                        <label for="quantity" class="font-medium">Minimum</label>
                                        <p-inputNumber [(ngModel)]="admission.min" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputNumber>
                                      </div>
        
                                      <div class="field mb-4 col-12">
                                        <label for="ResourceOpt" class="font-medium">Maximum</label>
                                        <p-inputNumber [(ngModel)]="admission.max" [showButtons]="true" buttonLayout="horizontal" mode="decimal"></p-inputNumber>
                                      </div>
                                      <div *ngIf="admission.max < admission.min" class="text-danger" Style="margin-left:10px; margin-top: -15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Max admissions must be greater ot equal to Min admissions.</div>

                                      <div *ngIf="admission.max < 1" class="text-danger" Style="margin-left:10px; margin-top: -15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Max admissions must be greater than zero.</div>
                                      <!--         
                                        <div class="field mb-4 col-12">
                                          <label for="ResourceOpt" class="font-medium">Participant</label>
                                          <p-selectButton id="ppar" [options]="stateOptions" [(ngModel)]="admission.participant" ></p-selectButton>
                                        </div>
                                      -->
                                      <div class="field mb-4 col-12">
                                        <label for="quantity" class="font-medium">Price:</label>
                                        <p-inputNumber  [(ngModel)]="admission.price" [showButtons]="true" buttonLayout="horizontal" mode="currency" currency="{{CurrencySymbol}}"></p-inputNumber>
                                      </div>

                                        <div class="field mb-4 col-12">
                                            <label for="quantity" class="font-medium">Details Required:</label>
                                            <p-selectButton id="ppar" [options]="stateOptions" [(ngModel)]="admission.detailsrequired" ></p-selectButton>
                                        </div>
    
                                    </div>
                                  </div>
                                </p-accordionTab>
                              </p-accordion>
                            </td>
                            <td>
                              <button pButton pRipple type="button" [style]="{'margin-bottom': '10px'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromAdmissions(admission)">
                                <span class="pi pi-angle-left"></span>
                              </button>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>

                    </div>
                  </div>
                </div>
                <div *ngIf="!admissionsValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one admission.</div>
              

                <div style="margin-top:20px;" class="field mb-4 col-12">
                  <label for="packages" class="font-medium">Does this membership apply to all packages or selected packages</label>
                  <p-selectButton [ngStyle]="{'display': 'block', 'width': '500px'}" [options]="stateOptionsPackageScope" [(ngModel)]="Membership.packagescope" ></p-selectButton>
                </div>

                <div *ngIf="Membership.packagescope == 'SELECTED'" class="surface-card p-4 shadow-2 border-round" style="width:100%;">
                  
                  <div class="grid formgrid p-fluid">
                  
                  <div class="col-12 md:col-6 drag-column">
                    <label class="font-medium">Available Packages</label>
      
                    <p-table [value]="ListPackages">
                      <ng-template pTemplate="header">
                          <tr>
                              <th style="width:90%">Name</th>
                              <th style="width:10%">&nbsp;</th>
                          </tr>
                      </ng-template>
                          <ng-template pTemplate="body" let-package>
                            <tr pDraggable="packages" (onDragStart)="dragStart($event, package)" (onDragEnd)="dragEnd()">
                                <td>{{package.name}}</td>
                                <td>
                                  <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToList(package)">
                                    <span class="pi pi-angle-right"></span>
                                  </button>
                                </td>
                            </tr>
                          </ng-template>
      
                      </p-table>
      
      
                      <div *ngIf="ListPackages == null" style="padding: 15px;">
                      <i>No packages available, add some <a href="packageedit/0">here</a></i>
      
                      </div>
                  </div>
      
                  <div class="col-12 md:col-6 drop-column" pDroppable="packages" (onDrop)="drop()">
                    <label class="font-medium">Selected Packages</label>
      
                    <p-table [value]="Membership.pPackages">
                      <ng-template  pTemplate="header" let-columns>
                          <tr>
                              <th style="width:90%">Name</th>
                              <th style="width:10%">&nbsp;</th>
                          </tr>
                      </ng-template>
                          <ng-template pTemplate="body" let-package let-columns="columns" let-index="rowIndex">
                            <tr>
                                <td>{{package.name}}</td>
                                <td>
                                  <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="RemoveFromList(package)">
                                    <span class="pi pi-angle-left"></span>
                                  </button>
                                </td>
                            </tr>
                          </ng-template>
      
                      </p-table>
                  </div>
                  </div>
              </div>
              <div *ngIf="!packagesValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one package.</div>
              

                <div class="field mb-4 col-12">
                  <label for="packageRule" class="font-medium">Booking Questionnaire (Questionnaire must not contain birthday questions)</label>
                  <p-dropdown [options]="BookingQuestionnaires" [(ngModel)]="Membership.questionnaire" placeholder="No Questionnaire" [showClear]="true" optionLabel="name"></p-dropdown>
                </div>

                 <div style="clear:both; width:100%"></div>
                <!-- <div style="margin-top:20px;" class="field mb-4 col-12">
                  <label for="customeremail" class="font-medium">Send the customer their membership details:</label>
                  <p-selectButton [ngStyle]="{'display': 'block', 'width': '500px'}"  [options]="stateOptions" [(ngModel)]="Membership.membershipemail" ></p-selectButton>
                </div> -->

                <div  class="field mb-4 col-12">
                  <label for="emailtemplate" class="font-medium">Email Template: (This template confirms the customer’s membership details, usage instructions, and provides their membership number and PIN)</label>
                  <p-dropdown [options]="EmailTemplates" placeholder="Select template" [(ngModel)]="Membership.emailtemplate" optionLabel="name" [showClear]="true"></p-dropdown>
                </div>
                
                <div *ngIf="!emailTemplateValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select an email template.</div>

                <div class="col-12">
                    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    Save Changes</button>
                    &nbsp;
                    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                    <span class="pi pi-times" style="margin-right:8px;"></span>
                    Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>